import { z } from "zod";
import { voiceGuesserReactionEmojiSchema } from "./game.js";

export const sendVoiceGuesserReactionSchema = z.object({
	emoji: voiceGuesserReactionEmojiSchema,
});

export type SendVoiceGuesserReactionPayload = z.infer<typeof sendVoiceGuesserReactionSchema>;
